/**
 * Only display children if we're in fullscreen mode.
 */

import { useAppStore } from "@/common/store/appStore";

interface IProps {
  children: React.ReactNode;
}

export const FullScreenOnly = ({ children }: IProps) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);

  if (!isFullScreen) {
    return null;
  }

  return <>{children}</>;
};
